import { CalendarDays } from "lucide-react";
import { isValid } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { fromISO, shortDate, toISO } from "./dates";

const btnCls = "w-full h-9 rounded-md bg-slate-800 border border-slate-600 px-3 text-sm text-left flex items-center gap-2 hover:border-[#818CF8] transition-colors";

export function RangePick({ start, end, onChange, testId }) {
  const selected = start ? { from: fromISO(start), to: end ? fromISO(end) : undefined } : undefined;
  const label = start ? `${shortDate(start)} – ${end ? shortDate(end) : "…"}` : "Pick the week";
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className={btnCls}>
          <CalendarDays className="w-4 h-4 text-[#22D3EE]" /><span className={start ? "text-slate-100" : "text-slate-500"}>{label}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#0b1526] border-white/10" align="start">
        <Calendar mode="range" selected={selected} weekStartsOn={0} defaultMonth={selected?.from}
          onSelect={(r, day) => {
            if (start && end && day) return onChange(toISO(day), "");
            onChange(r?.from ? toISO(r.from) : "", r?.to ? toISO(r.to) : "");
          }} />
        <div className="flex justify-between items-center px-3 pb-2 text-[11px] text-slate-400">
          <span>{start && !end ? "Now pick the last day" : "Click a start day, then an end day"}</span>
          <button type="button" data-testid="lp-week-range-clear" onClick={() => onChange("", "")} className="text-[#22D3EE] hover:underline">Clear</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export function DayPick({ value, onChange, placeholder = "Pick a date", testId }) {
  const parsed = value ? fromISO(value) : null;
  const valid = parsed && isValid(parsed);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} className={btnCls}>
          <CalendarDays className="w-4 h-4 text-[#22D3EE]" /><span className={valid ? "text-slate-100" : "text-slate-500"}>{valid ? shortDate(value) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-[#0b1526] border-white/10" align="start">
        <Calendar mode="single" selected={valid ? parsed : undefined} defaultMonth={valid ? parsed : undefined}
          onSelect={(d) => onChange(d ? toISO(d) : "")} />
      </PopoverContent>
    </Popover>
  );
}
